<template>
    <div class="wrapper">
        <div v-if="notice" class="notice-detail padding-sm margin-bottom-sm flex-sub">
            <div class="flex align-start justify-between margin-bottom-sm">
                <h3 class="notice-title">{{ notice.title }}<span>({{ notice.state | status }})</span></h3>
                <el-button class="blue-btn" round type="primary" @click="$router.go(-1)"
                >返回
                </el-button
                >

            </div>
            <div v-if="notice.state === 2" class="notice-reason">
                拒绝原因：{{ notice.state_msg }}
            </div>
            <div class="notice-num margin-bottom-sm">
                <span class="margin-right-xs">通知类型：<i>{{ notice.is_feedback === 1 ? '反馈通知' : '普通通知' }}</i> </span>
            </div>

            <div class="notice-info" v-html="notice.content"></div>

            <div v-if="notice.file_json.length>0" class="margin-tb-sm">
                <h3 class="margin-bottom-xs">附件</h3>
                <div v-for="(items,index) in notice.file_json" :key="index" class="flex align-center margin-bottom-xs">
                    <el-link :href="items.url" class="margin-right" target="_blank">{{ items.name }}</el-link>
                    <el-button type="text" @click="downloadFile(items.url,items.name)">下载</el-button>
                </div>
            </div>

            <div class="flex justify-end">
                <el-button v-if="notice.state === 1" class="goback" round @click="apply(2)">拒绝
                </el-button>
                <el-button v-if="notice.state === 1" class="line-btn margin-left-xs" round @click="apply(3)">通过
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
import {examineNoticeData, noticeDetail} from '@/api/organiz'
import {downloadFile} from '@/api/login'
import {zhDate} from '@/utils/utils'

export default {
    name: "detail",
    components: {},
    data() {
        return {
            keyWord: '',
            notice: null,

        }
    },
    created() {
        this.$emit('setIndex', [1, 0], '通知公告')
        this.getDetail()
    },
    computed: {
        noticeId() {
            return this.$route.params.id
        },
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        apply(state) {
            if (state === 3) {
                this.$confirm(`你确定通过该通知公告吗?`, '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.submitApply(state, '')
                })
            } else {
                this.$prompt('请输入拒绝原因', '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /\S/,
                    inputErrorMessage: '请输入拒绝原因'
                }).then(({value}) => {
                    this.submitApply(state, value)
                })
            }

        },
        async submitApply(state, value) {
            let _state = await examineNoticeData(this.noticeId, value, state)
            if (_state.status === 200) {
                this.$message.success(_state.msg)
                this.$router.go(-1)
            }
        },
        async getDetail() {
            let _data = await noticeDetail(this.noticeId)
            this.notice = _data.data
            this.notice.file_json = JSON.parse(this.notice.file_json)
        },

        async downloadFile(fileUrl, fileName) {
            if (!fileUrl) {
                return;
            }
            let _data = await downloadFile(fileUrl)
            let url = window.URL.createObjectURL(new Blob([_data.data]));
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        }
    },
    filters: {
        time(val) {
            return val ? zhDate(val * 1000) : '--'
        },
        status(type) {
            switch (Number(type)) {
                case 1:
                    return "待审核";
                case 2:
                    return "审核驳回";
                default:
                    return "审核通过";
            }
        }
    }

}
</script>

<style lang="scss" scoped>
.wrapper {
    .notice-detail {
        background: #fff;
        border-radius: 10px;

        .notice-title {
            width: 80%;
            font-size: 26px;
            line-height: 40px;
            color: #333333;
            span{
                font-size: 16px;
                color: #fc4902;
            }
        }

        .goback {
            background: #0a2240;
            border: 1px solid #0a2240;
            width: 100px;
            color: #FFFFFF;
        }

        .notice-num {
            i {
                color: #ffb400;

                &.active {
                    color: #fc4902;
                }
            }
        }
    }

    .notice-reason{
        border: 1px dashed #fc4902;
        padding: 10px;
        margin-bottom: 10px;
    }
    .feedback-box {
        background: #fff;
        border-radius: 10px;

        .feedback-title {
            line-height: 40px;
            font-size: 26px;
        }

        .feedback-export {
            width: 200px;
            background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
            linear-gradient(#0a2240, #0a2240);
            background-blend-mode: normal, normal;
        }

        .notice-num {
            i {
                color: #ffb400;

                &.active {
                    color: #fc4902;
                }
            }
        }

        .feedback-search {
            .el-input__inner {
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
            }

            .el-button {
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
                background: #0a2240;
                border: 0;
                font-size: 16px;
            }
        }
    }
}
</style>